// Placeholder dev vhosts; real production vhost to be supplied later.
const SLT_EXPORT_VHOSTS = new Set(["slt.com.pl", "mike", "szymon"])

export const isSltExportEnabledVhost = (vhost: string | undefined): boolean =>
  SLT_EXPORT_VHOSTS.has(vhost ?? "")
